<template>
  <v-container class="mt-2 productContainer">
    <v-row>
        <v-col cols="12">
          <strong>
            <h3>Our Global Manufacturers</h3>
          </strong>
        </v-col>
    </v-row>

    <v-row>
        <v-col cols="12" md="4" v-for="(item, index) in allManufacturers" :key="index" >
           
             <v-card
              class="mx-auto my-12"
              max-width="auto"
            >
              <template slot="progress">
                <v-progress-linear
                  color="deep-purple"
                  height="10"
                  indeterminate
                ></v-progress-linear>
              </template>

              <v-card-title>{{item.companyName}}</v-card-title>

              <v-card-text>
                <v-row
                  align="center"
                  class="mx-0"
                >
                  <v-rating
                    :value="4.5"
                    color="amber"
                    dense
                    half-increments
                    readonly
                    size="14"
                  ></v-rating>
                </v-row>

                <div class="my-4 text-subtitle-1">
                  • {{item.User.state}}, {{item.User.country}}
                </div>

                <div>{{item.description}}</div>
              </v-card-text>

            </v-card>
        </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "Manufacturers",

  data: () => ({
    allManufacturers:[],
  }),
  created() {
    this.fetchManufacturers();
  },
  methods: {
    fetchManufacturers() {
      this.$http
        .get(`${process.env.VUE_APP_URL}manufacturers`)
        .then((response) => {
          this.allManufacturers = response.data.data;
        });
    },
  },
};
</script>

<style scoped>
.productContainer {
  background-color: #f2f2f2;
  border-radius: 10px;
  padding: 50px;
}
</style>
